export default "__VITE_ASSET__26aa9f66__"